import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { TranslatePipe } from '../translate.pipe'

@Component({
  selector: 'pai-input-field-error-message',
  imports: [TranslatePipe],
  template: `<span>{{ key() | translate: value() }}</span>`,
  styleUrl: './input-field-error-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-label]': 'key()',
  },
})
export class InputFieldErrorMessageComponent {
  readonly key = input.required<string>()
  readonly value = input<null | Record<string, any>>(null)
}
